import { defineComponent as _defineComponent } from 'vue'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-surplus-size-err-modal',
  props: {
    visible: { type: Boolean },
    prolineId: null,
    prolineName: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  visible: boolean
  prolineId: string | number
  prolineName: string
}





const handleOk = () => {
  router.push(
    `/engraving?setting_id=${props.prolineId}&line=${props.prolineName}&equipType=engraving&tab=saw`
  )
}

const handleClose = () => {
  emit('close')
}

return { __sfc: true,props, emit, handleOk, handleClose }
}

})